import React from 'react'
import { useWindowDimensions, ScrollView, View, Image } from 'react-native'
import { Text, Button } from '@ui-kitten/components'
import tailwind from 'tailwind-rn'
import { useNavigation } from '@react-navigation/native'
import HeaderInterno from '../components/HeaderInterno'
import FooterInterno from '../components/FooterInterno'
import FooterMenu from '../components/FooterMenu'
import { useMediaQuery } from 'react-responsive'
import RenderHtml from 'react-native-render-html'
import YoutubePlayer from "react-native-youtube-iframe"

import Colors from '../constants/Colors'

import { SafeAreaView } from 'react-native-safe-area-context'

const source1 = {
  html: `
<p style='text-align:left; font-size: large; font-weight: bold; color: #5c0b78'>Fundamento do Growth</p>
<p style='text-align:left; font-size: smaller; line-height: 18px;'>Introduzir Estratégias, Conceitos e Tecnologias de Growth e iniciar os participantes na aplicação do Growth em seus negócios e dos seus clientes e parceiros.</p>
<ul>
<li>Ciclo 1: <strong>Fundamentos do Growth</strong></li>
<li>Ciclo 2: <strong>Growth para Crescimento dos Negócios</strong></li>
<li>Ciclo 3: <strong>Estratégia Empresarial Growth</strong></li>
</ul>
`
};

const source2 = {
  html: `
  <ul>
    <li>Introdução ao Growth Bahia</li>
    <li>Growtitude, a sua Máquina de Crescimento de Negócios</li>
    <li>Principais Armadilhas e Riscos em Programas de Growth</li>
    <li>Crescendo o seu negócio na velocidade das Startups</li>
    <li>Multiplique o seu faturamento por meio de dados</li>
    <li>Tudo para crescer: negócio organizado e equipes vencedoras</li>
    <li>Relacionamento com Clientes e Serviços Digitais</li>
    <li>Tendências do Growth e Visão de Futuro</li>
  </ul>
  `
}

const source3 = {
  html: `
<p style='text-align:left; font-size: large; font-weight: bold; color: #5c0b78'>Alexandre Galliotti</p>
<p style='text-align:left; font-size: smaller; line-height: 18px;'>Alexandre Galliotti é um Digital Dealmaker. Executivo Data-Driven, fluente em conceitos e plataformas de Martech, Growth & CX, como CRM, Analytics e DMPs.  Advisor e Mentor da Startups Inovativa Brasil e Harvard MIT. Consultor e Palestrante. Projetos de alto ROI para empresas como XP, Microsoft, Globo, Bradesco, IBM, Itaú, Oi, Google, Gol, Salesforce, Whirlpool, Nubank, UOL/PagSeguro.</p>
`
};

const source4 = {
  html: `
<p style='text-align:left; font-size: large; font-weight: bold; color: #5c0b78'>Claudio Cardoso</p>
<p style='text-align:left; font-size: smaller; line-height: 18px;'>Claudio Cardoso é um profissional da comunicação estratégica e do data-driven marketing. Tem 40 anos de uma carreira que combina comunicação e tecnologia de informação. Pós Doutor em Comunicação. Integra conselhos de Adtechs e Commtechs. Designer de conceitos e processos dos hubs de inovação do Bradesco (InovaBra Habitat), do Estado de São Paulo (IPT Open) e do Banco Alfa (Alfa Collab).</p>
`
};

const source5 = {
  html: `
<p style='text-align:left; font-size: large; font-weight: bold; color: #5c0b78'>Objetivo</p>
<p style='text-align:left; font-size: smaller; line-height: 18px;'>Ajudar empresas do ecossistema de Comércio e Serviços da Bahia com o que há de mais atual em Estratégias, Conceitos e Tecnologias de Growth para o crescimento acelerado e sustentável dos negócios.</p>
<p style='text-align:left; font-size: large; font-weight: bold; color: #5c0b78'>O que é</p>
<p style='text-align:left; font-size: smaller; line-height: 18px;'>Growth é uma metodologia orientada ao crescimento dos negócios, focada na mudança de mentalidade empresarial, que contribui para a qualificação das equipes das empresas. A metodologia utiliza instrumentos criados pelo marketing digital, acessíveis a todo tamanho de negócio, e combina com ferramentas fáceis de utilizar e de baixo custo.<br/>Growth vai além de uma única área como Marketing ou Vendas. Ele é uma visão macro e busca oportunidades e alavancas de crescimento em todas as esferas e estruturas do negócio. Sempre apontando para o crescimento como resultado do “olhar para geração de valor” em todas as etapas da Jornada de Experiência do Consumidor.</p>
<p style='text-align:left; font-size: large; font-weight: bold; color: #5c0b78'>Vantagens</p>
<p style='text-align:left; font-size: smaller; line-height: 18px;'>A grande vantagem do Growth é a geração de resultados tangíveis a curto e médio prazos. Além disso, permite aplicações variadas e se adapta a todo tipo de negócio e ambiente. O Growth é replicável por meio de capacitação, sem necessidade de aquisição de recursos. Esta é a aposta do Senac Bahia, em conjunto com a Growth 3D, empresa especializada na metodologia.<br/>Growth auxilia todas as áreas do negócio por meio de indicadores e metas de crescimento. Ele orienta melhorias do produto para obter maior retenção e ampliar a lealdade do consumidor, explorando canais e reduzindo o custo de aquisição dos clientes.</p>
`
};

export default function Growth() {

  const isLargeScreen = useMediaQuery({minDeviceWidth: 440})
  const windowWidth = isLargeScreen ? 800 : useWindowDimensions().width
  const windowHeight = useWindowDimensions().height
  const navigation = useNavigation()

  const _goForm = () => {
    navigation.navigate('FormRD', {})
//    Linking.openURL('https://docs.google.com/forms/d/e/1FAIpQLSclP-vGIjG0gj9MtWVaWq21AAcHxuBhAVETRdPLAacHsgdYCA/viewform?vc=0&c=0&w=1&flr=0')
  }

      return (
        <SafeAreaView style={{flex:1, backgroundColor: "#ece7e7"}}>
          <HeaderInterno title="PROGRAMA GROWTH" subtitle="Crescimento Acelerado" />
          <ScrollView style={{height: windowHeight, width: windowWidth}}>
            <View style={[tailwind('bg-white mx-7 mt-5 mb-40'), { shadowColor: '#000', shadowOffset: {width: 0, height: 4}, shadowOpacity: 0.5, shadowRadius: 4.85, borderRadius: 20 }]}>
            <View style={[tailwind('mb-10'), {marginTop: isLargeScreen ? 110 : 150}]}>
                  <>
                <View style={tailwind('mx-5')}>
                  <RenderHtml
                    contentWidth={100}
                    source={source1}
                  />
                </View>  
                <View style={[tailwind('bg-black my-3'), { height: 1 }]} />
                <View style={tailwind('mx-5 self-center')}>
                  <YoutubePlayer
                    height={isLargeScreen ? 350 : 190}
                    width={isLargeScreen ? 600 : windowWidth - 70}
                    videoId={"dZQ-kG5g9BE"}
                  />
                </View>
                <Button nativeID="btn" size="large" style={[tailwind('self-center'), {marginTop: 10, marginBottom: 10, borderRadius: 20, borderColor: Colors.laranja_forte, backgroundColor: Colors.laranja_forte, width: windowWidth/2}]} onPress={_goForm}><Text style={{color: Colors.roxo, fontWeight: 'bold'}}>INSCREVA-SE</Text></Button>
                <Text style={[tailwind('my-3 font-bold p-5'), { backgroundColor: Colors.roxo, color: 'white' }]}>CONTEÚDO DA FORMAÇÃO BÁSICA</Text>
                <View style={tailwind('mx-5')}>
                  <RenderHtml
                    contentWidth={100}
                    source={source2}
                  />
                </View>
                <View style={[tailwind('bg-black my-3'), { height: 1 }]} />
                <View style={tailwind('mx-5 self-center')}>
                  <YoutubePlayer
                    height={isLargeScreen ? 350 : 190}
                    width={isLargeScreen ? 600 : windowWidth - 70}
                    videoId={"XhK4kitz7O0"}
                  />
                </View>
                <Button nativeID="btn" size="large" style={[tailwind('self-center'), {marginTop: 10, marginBottom: 10, borderRadius: 20, borderColor: Colors.laranja_forte, backgroundColor: Colors.laranja_forte, width: windowWidth/2}]} onPress={_goForm}><Text style={{color: Colors.roxo, fontWeight: 'bold'}}>INSCREVA-SE</Text></Button>
                <Text style={[tailwind('my-3 font-bold p-5'), { backgroundColor: Colors.roxo, color: 'white' }]}>EQUIPE</Text>
                <View style={tailwind('mx-5')}>
                  <View style={{height: 100, width: 100, shadowColor: '#000', shadowOffset: {width: 0, height: 4}, shadowOpacity: 0.5, shadowRadius: 4.85, borderRadius: 80}}>
                    <Image source={require('../assets/images/alexandre.png')} style={{height: 100, width: 100, borderColor: 'white', borderWidth: 4, borderRadius: 80}} />
                  </View>
                  <RenderHtml
                    contentWidth={100}
                    source={source3}
                  />
                </View>  
                <View style={tailwind('mx-5 mt-2')}>
                  <View style={{height: 100, width: 100, shadowColor: '#000', shadowOffset: {width: 0, height: 4}, shadowOpacity: 0.5, shadowRadius: 4.85, borderRadius: 80}}>
                    <Image source={require('../assets/images/claudio.png')} style={{height: 100, width: 100, borderColor: 'white', borderWidth: 4, borderRadius: 80}} />
                  </View>
                  <RenderHtml
                    contentWidth={100}
                    source={source4}
                  />
                </View>  
                <View style={[tailwind('bg-black my-3'), { height: 1 }]} />
                <Button nativeID="btn" size="large" style={[tailwind('self-center'), {marginTop: 10, marginBottom: 10, borderRadius: 20, borderColor: Colors.laranja_forte, backgroundColor: Colors.laranja_forte, width: windowWidth/2}]} onPress={_goForm}><Text style={{color: Colors.roxo, fontWeight: 'bold'}}>INSCREVA-SE</Text></Button>
                <Text style={[tailwind('my-3 font-bold p-5'), { backgroundColor: Colors.roxo, color: 'white' }]}>DESCRIÇÃO COMPLETA</Text>
                <View style={tailwind('mx-5')}>
                  <RenderHtml
                    contentWidth={100}
                    source={source5}
                  />
                </View>  
                <View style={[tailwind('bg-black my-3'), { height: 1 }]} />
                <Button nativeID="btn" size="large" style={[tailwind('self-center'), {marginTop: 10, marginBottom: 10, borderRadius: 20, borderColor: Colors.laranja_forte, backgroundColor: Colors.laranja_forte, width: windowWidth/2}]} onPress={_goForm}><Text style={{color: Colors.roxo, fontWeight: 'bold'}}>INSCREVA-SE</Text></Button>
                </>
              </View>
            </View>
            {!isLargeScreen && <FooterInterno />}
          </ScrollView>
          <FooterMenu />
        </SafeAreaView>
      )


}
